import { SliceCaseReducers } from '@reduxjs/toolkit'
import {
  InvestmentProductsByTypeParams,
  InvestmentProductsByTypeResponse,
} from '@repo/accounts-types'
import { ApiResponse, createOperationSlice, GenericOperationState } from '@repo/core'

const initialState: GenericOperationState<ApiResponse<InvestmentProductsByTypeResponse> | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: productsByTypeDataActions, reducer: productsByTypeDataReducer } =
  createOperationSlice<
    ApiResponse<InvestmentProductsByTypeResponse> | null,
    SliceCaseReducers<GenericOperationState<ApiResponse<InvestmentProductsByTypeResponse> | null>>,
    InvestmentProductsByTypeParams
  >({
    name: '@accounts/detail/read/productsByType',
    initialState,
    reducers: {},
  })
